<template>
  <div>
    <router-view />
    <NetworkStatusNotification/>
  </div>
</template>

<script>
  import NetworkStatusNotification from "@/pages/NetworkStatusNotification.vue";

  export default {
    name: 'App',
    components: {NetworkStatusNotification},
    head: {
      title: {
        inner:  process.env.VUE_APP_NATIONAL_PROJECT_TYPE === 'INTERNATIONAL' ? 'RinoEdu' : 'VH - CRM',
        separator: ' ',
      },
      link: [
        {
          rel: 'icon',
          type: 'image/svg+xml',
          href: process.env.VUE_APP_NATIONAL_PROJECT_TYPE === 'INTERNATIONAL'
              ? './icon.png'
              : './logo.png'
        }
      ]
    },
    created() {
      console.log(process.env.VUE_APP_NATIONAL_PROJECT_TYPE === 'INTERNATIONAL')
    }
  }
</script>
<style lang="scss">
html {
  overflow-y: auto
}
</style>
